import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { DYNAMIC_TARIFF_GRADIENT_LEGEND } from '../../../constants/legends';

const DynamicTariffVoronoiComponent = () => (
    <div>
        <LegendRenderer config={DYNAMIC_TARIFF_GRADIENT_LEGEND} />
        <div style={{ padding: '10px' }}>
            <small>{t`Обновление раз в 4 минуты`}</small>
        </div>
    </div>
);

export const DynamicTariffVoronoiLegendH3 = withDisplayedLayersCheck(DynamicTariffVoronoiComponent, t`Динамический тариф_h3`);
